// import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import './StudentApplicationForm.css';
// import axios from 'axios';
// import { FaDownload, FaEye } from 'react-icons/fa';
// import { Slidar } from '../AdminDashbord/Slidar'; 

// const StudentInfoDisplay = () => {
//   const [applications, setApplications] = useState([]);
//   const [filteredApps, setFilteredApps] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [filterEdu, setFilterEdu] = useState('');
//   const [currentPage, setCurrentPage] = useState(1);
//   const navigate = useNavigate();
//   const itemsPerPage = 5;

//   useEffect(() => {
//     axios.get('/api/students/applications')
//       .then((res) => {
//         setApplications(res.data);
//         setFilteredApps(res.data);
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error("Failed to fetch applications", err);
//         setLoading(false);
//       });
//   }, []);

//  useEffect(() => {
//   let filtered = applications;

//   if (searchTerm) {
//     const term = searchTerm.trim().toLowerCase();

//     filtered = filtered.filter(app =>
//       (app?.name?.toLowerCase().includes(term)) ||
//       (app?.email?.toLowerCase().includes(term)) ||
//       (app?.mobile?.toString().toLowerCase().includes(term)) ||
//       (app?.jobTitle?.toLowerCase().includes(term))
//     );
//   }

//   if (filterEdu) {
//     filtered = filtered.filter(app => app?.education === filterEdu);
//   }

//   setFilteredApps(filtered);
//   setCurrentPage(1);
// }, [searchTerm, filterEdu, applications]);


//   const indexOfLast = currentPage * itemsPerPage;
//   const indexOfFirst = indexOfLast - itemsPerPage;
//   const currentItems = filteredApps.slice(indexOfFirst, indexOfLast);
//   const totalPages = Math.ceil(filteredApps.length / itemsPerPage);
//   const handlePageChange = (page) => setCurrentPage(page);

//   if (loading) return <div className="student-form-container"><h3>Loading student data...</h3></div>;

//   return (
    
//     <div className="admin-layout">
//       <Slidar />
//       <div className="student-main-content">
//         <h2>Students Applications</h2>
//         <div className="top-controlss">
//           <input
//             type="text"
//             placeholder=" Search.."
//             className="search-box"
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//           />
//           <select
//             className="filter-select"
//             value={filterEdu}
//             onChange={(e) => setFilterEdu(e.target.value)}
//           >
//             <option value=""> Filter by Education</option>
//             {[...new Set(applications.map(app => app.education))].map((edu, i) => (
//               <option key={i} value={edu}>{edu}</option>
//             ))}
//           </select>
//         </div>
// <div className="table-wrapper">
//         <table className="student-table">
//          <thead>
//   <tr>
//     <th>SL No.</th>
//     <th>Job Title</th> {/* ✅ Add this line */}
//     <th>Name</th>
//     <th>Email</th>
//     <th>Contact</th>
//     <th>Education</th>
//     <th>Resume</th>
//   </tr>
// </thead>

//        <tbody>
//   {currentItems.length === 0 ? (
//     <tr><td colSpan="7">No applications found</td></tr>
//   ) : (
//     currentItems.map((data, index) => (
//       <tr key={index}>
//         <td>{indexOfFirst + index + 1}</td>
//         <td>{data.jobTitle}</td> {/* ✅ Fix applied here */}
//         <td>{data.name}</td>
//         <td>{data.email}</td>
//         <td>{data.mobile}</td>
//         <td>{data.education}</td>
//         <td>
//           <a href={`/uploads/${data.resumeFilename}`} target="_blank" rel="noopener noreferrer">
//             <FaEye style={{ marginRight: 10 }} />
//           </a>
//           <a href={`/uploads/${data.resumeFilename}`} download>
//             <FaDownload />
//           </a>
//         </td>
//       </tr>
//     ))
//   )}
// </tbody>


//         </table>
//         </div>

//         <div className="pagination">
//           {Array.from({ length: totalPages }, (_, i) => (
//             <button
//               key={i + 1}
//               className={`page-btn ${currentPage === i + 1 ? 'active' : ''}`}
//               onClick={() => handlePageChange(i + 1)}
//             >
//               {i + 1}
//             </button>
//           ))}
//         </div>
//         <button onClick={() => navigate('/careers')} className="reset-btn">⬅ Back to Careers</button>
//       </div>
//     </div>
//   );
// };

// export default StudentInfoDisplay;

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './StudentApplicationForm.css';
import axios from 'axios';
import { FaDownload, FaEye, FaEdit, FaTrash } from 'react-icons/fa';
import { Slidar } from '../AdminDashbord/Slidar';

const StudentInfoDisplay = () => {
  const [applications, setApplications] = useState([]);
  const [filteredApps, setFilteredApps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterEdu, setFilterEdu] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const navigate = useNavigate();

  // Inline editing states
  const [editingId, setEditingId] = useState(null);
  const [editFormData, setEditFormData] = useState({});

  useEffect(() => {
    fetchApplications();
  }, []);

  const fetchApplications = () => {
    axios
      .get('/api/students/applications')
      .then((res) => {
        setApplications(res.data);
        setFilteredApps(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Failed to fetch applications', err);
        setLoading(false);
      });
  };

  useEffect(() => {
    let filtered = applications;

    if (searchTerm) {
      const term = searchTerm.trim().toLowerCase();
      filtered = filtered.filter(
        (app) =>
          app?.name?.toLowerCase().includes(term) ||
          app?.email?.toLowerCase().includes(term) ||
          app?.mobile?.toString().toLowerCase().includes(term) ||
          app?.jobTitle?.toLowerCase().includes(term)
      );
    }

    if (filterEdu) {
      filtered = filtered.filter((app) => app?.education === filterEdu);
    }

    setFilteredApps(filtered);
    setCurrentPage(1);
  }, [searchTerm, filterEdu, applications]);

  // Pagination logic
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentItems = filteredApps.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredApps.length / itemsPerPage);
  const handlePageChange = (page) => setCurrentPage(page);

  // === Delete Student Application ===
  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this application?')) return;
    try {
      await axios.delete(`/api/students/applications/${id}`);
      alert('Application deleted successfully');
      fetchApplications(); // refresh list
    } catch (error) {
      console.error('Error deleting application:', error);
      alert('Failed to delete application');
    }
  };

  // === Start Editing ===
  const handleEdit = (app) => {
    setEditingId(app._id);
    setEditFormData({ ...app });
  };

  // === Cancel Editing ===
  const handleCancelEdit = () => {
    setEditingId(null);
    setEditFormData({});
  };

  // === Save Edit ===
  const handleSave = async (id) => {
    try {
      await axios.put(`/api/students/applications/${id}`, editFormData);
      alert('Application updated successfully');
      fetchApplications();
      setEditingId(null);
    } catch (err) {
      console.error('Error updating application:', err);
      alert('Failed to update application');
    }
  };

  // === Toggle Check ===
  const handleCheckToggle = async (id, checked) => {
    try {
      await axios.put(`/api/students/applications/${id}`, {
        isChecked: checked,
      });
      setApplications((prev) =>
        prev.map((app) =>
          app._id === id ? { ...app, isChecked: checked } : app
        )
      );
    } catch (err) {
      console.error('Error updating check status:', err);
      alert('Failed to update status');
    }
  };

  if (loading)
    return (
      <div className="student-form-container">
        <h3>Loading student data...</h3>
      </div>
    );

  return (
    <div className="admin-layout">
      <Slidar />
      <div className="student-main-content">
        <h2>Students Applications</h2>

        {/* Search & Filter */}
        <div className="top-controlss">
          <input
            type="text"
            placeholder=" Search.."
            className="search-box"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <select
            className="filter-select"
            value={filterEdu}
            onChange={(e) => setFilterEdu(e.target.value)}
          >
            <option value=""> Filter by Education</option>
            {[...new Set(applications.map((app) => app.education))].map((edu, i) => (
              <option key={i} value={edu}>
                {edu}
              </option>
            ))}
          </select>
        </div>

        {/* Table */}
        <div className="table-wrapper">
          <table className="student-table">
            <thead>
              <tr>
                <th>SL No.</th>
                <th>Job Title</th>
                <th>Name</th>
                <th>Email</th>
                <th>Contact</th>
                <th>Gender</th>
                <th>DOB</th>
                <th>Education</th>
                <th>Other Education</th>
                <th>Skills</th>
                <th>Resume</th>
                <th>Checked</th>
                <th>Created At</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {currentItems.length === 0 ? (
                <tr>
                  <td colSpan="14">No applications found</td>
                </tr>
              ) : (
                currentItems.map((data, index) => (
                  <tr key={data._id}>
                    <td>{indexOfFirst + index + 1}</td>

                    {editingId === data._id ? (
                      <>
                        <td>
                          <input
                            value={editFormData.jobTitle || ''}
                            onChange={(e) =>
                              setEditFormData({ ...editFormData, jobTitle: e.target.value })
                            }
                          />
                        </td>
                        <td>
                          <input
                            value={editFormData.name || ''}
                            onChange={(e) =>
                              setEditFormData({ ...editFormData, name: e.target.value })
                            }
                          />
                        </td>
                        <td>
                          <input
                            value={editFormData.email || ''}
                            onChange={(e) =>
                              setEditFormData({ ...editFormData, email: e.target.value })
                            }
                          />
                        </td>
                        <td>
                          <input
                            value={editFormData.mobile || ''}
                            onChange={(e) =>
                              setEditFormData({ ...editFormData, mobile: e.target.value })
                            }
                          />
                        </td>
                        <td>
                          <input
                            value={editFormData.gender || ''}
                            onChange={(e) =>
                              setEditFormData({ ...editFormData, gender: e.target.value })
                            }
                          />
                        </td>
                        <td>
                          <input
                            value={editFormData.dob || ''}
                            onChange={(e) =>
                              setEditFormData({ ...editFormData, dob: e.target.value })
                            }
                          />
                        </td>
                        <td>
                          <input
                            value={editFormData.education || ''}
                            onChange={(e) =>
                              setEditFormData({ ...editFormData, education: e.target.value })
                            }
                          />
                        </td>
                        <td>
                          <input
                            value={editFormData.percentage || ''}
                            onChange={(e) =>
                              setEditFormData({ ...editFormData, percentage: e.target.value })
                            }
                          />
                        </td>
                        <td>
                          <input
                            value={editFormData.skills || ''}
                            onChange={(e) =>
                              setEditFormData({ ...editFormData, skills: e.target.value })
                            }
                          />
                        </td>
                      </>
                    ) : (
                      <>
                        <td>{data.jobTitle}</td>
                        <td>{data.name}</td>
                        <td>{data.email}</td>
                        <td>{data.mobile}</td>
                        <td>{data.gender}</td>
                        <td>{data.dob}</td>
                        <td>{data.education}</td>
                        <td>{data.percentage}</td>
                        <td>{data.skills}</td>
                      </>
                    )}

                    {/* Resume */}
                    <td>
                      {data.resumeFilename ? (
                        <>
                          <a
                            href={`/uploads/${data.resumeFilename}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <FaEye style={{ marginRight: 10 }} />
                          </a>
                          <a
                            href={`/uploads/${data.resumeFilename}`}
                            download
                          >
                            <FaDownload />
                          </a>
                        </>
                      ) : (
                        "N/A"
                      )}
                    </td>

                    {/* Checked */}
                    <td>
                      <input
                        type="checkbox"
                        checked={data.isChecked || false}
                        onChange={(e) =>
                          handleCheckToggle(data._id, e.target.checked)
                        }
                      />
                    </td>

                    {/* Created At */}
                    <td>{new Date(data.createdAt).toLocaleString()}</td>

                    {/* Actions */}
                    <td>
                      {editingId === data._id ? (
                        <>
                          <button
                            onClick={() => handleSave(data._id)}
                            className="action-btn save-btn"
                          >
                            Save
                          </button>
                          <button
                            onClick={handleCancelEdit}
                            className="action-btn cancel-btn"
                          >
                            Cancel
                          </button>
                        </>
                      ) : (
                        <>
                          <button
                            onClick={() => handleEdit(data)}
                            className="action-btn edit-btn"
                          >
                            <FaEdit />
                          </button>
                          <button
                            onClick={() => handleDelete(data._id)}
                            className="action-btn delete-btn"
                          >
                            <FaTrash />
                          </button>
                        </>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="pagination">
          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i + 1}
              className={`page-btn ${currentPage === i + 1 ? 'active' : ''}`}
              onClick={() => handlePageChange(i + 1)}
            >
              {i + 1}
            </button>
          ))}
        </div>

        <button onClick={() => navigate('/careers')} className="reset-btn">
          ⬅ Back to Careers
        </button>
      </div>
    </div>
  );
};

export default StudentInfoDisplay;
